
import { Add, Delete, Edit } from '@mui/icons-material';
import { Grid2, IconButton, List, ListItem, ListItemButton, ListItemText, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { AppState, brandNewExcelTabStruct, ExcelTabColumnProps, excelTabEditorSlice, ExcelTabStructAttrs, excelTabStructSelector, excelTabStructSlice } from 'cdx-common';

import React from 'react';
import { useSelector } from 'react-redux';
import { appStore } from '../../store';

/*interface TabPanelProps {
    children?: React.ReactNode,
    index: number,
    value: number;
}
    */
/*
function TabPanel(props: TabPanelProps) {
    const { children, index, value, ...other } = props;

    return (
        <div
            role="tabpanel"
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
    */
/*
function a11yProps(index: ModelId) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}
    */

export const ExcelTabStructEditor = () => {

    const excelTabStructs = useSelector((state: AppState) => excelTabStructSelector.selectAll(state));
    //const [currentTabStruct, setCurrentTabStruct] = React.useState<number | null>(null);
    const editingExcelTabStruct = useSelector((state: AppState) => state.excelTabEditor.editingExcelTabStruct);
    /*
    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        if (newValue == -1) {
            const newId = crypto.randomUUID();
            appStore.dispatch(excelTabEditorSlice.actions.updateExcelTabStruct({
                ...brandNewExcelTabStruct,
                id: newId,
            }));
            setCurrentTabStruct(null);
        } else if (newValue) {
            setCurrentTabStruct(newValue);
            appStore.dispatch(excelTabEditorSlice.actions.updateExcelTabStruct({ ...excelTabStructs[newValue] }));
        }
    };
    */

    const editTabStruc = (p: ExcelTabStructAttrs) => {
        appStore.dispatch(excelTabEditorSlice.actions.updateExcelTabStruct({ ...p }));
    };
    const newTabStruct = () => {
        const newTabStruct = {
            ...brandNewExcelTabStruct,
            name: 'Nouvelle extration',
            tabName: 'TAB_',
            id: crypto.randomUUID(),
        };
        appStore.dispatch(excelTabEditorSlice.actions.updateExcelTabStruct({ ...newTabStruct }));
        appStore.dispatch(excelTabStructSlice.actions.addOne(newTabStruct));
    };
    console.log('editingExcelTabStruct', editingExcelTabStruct);

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
        >
            <Box sx={{ width: 250, borderRight: 1, borderColor: 'divider' }}>
                <List>
                    {excelTabStructs.map((excelTabStruct, index) => <ListItemButton onClick={() => { editTabStruc(excelTabStruct); }} key={index}><ListItemText primary={excelTabStruct.name !== '' ? excelTabStruct.name : 'Nouveau'} /></ListItemButton>)}
                    <ListItemButton onClick={newTabStruct} ><ListItemText primary={'Nouvelle'} /></ListItemButton>
                </List>
            </Box>
            {/*<Tabs
                orientation="vertical"
                variant="scrollable"
                value={currentTabStruct}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: 'divider' }}
            >
                {excelTabStructs.map((excelTabStruct, index) => <Tab key={index} label={excelTabStruct.name} {...a11yProps(index)} />)}
                <Tab key='new' label='Nouvel extracteur' {...a11yProps(-1)} />
            </Tabs>*/}
            <Box sx={{ flexGrow: 1 }}>
                {!!editingExcelTabStruct && <ExcelTabStructForm />}
            </Box>
            {/*excelTabStructs.map((excelTabStruct, index) => <TabPanel key={excelTabStruct.id} value={currentTabStruct} index={index}>
                <ExcelTabStructForm id={excelTabStruct.id} />
            </TabPanel>)*/}
        </Box>
    );
};

const FormEl = (props: { children?: React.ReactNode; }) => {
    return <Box sx={{ m: 1, p: 1 }}>{props.children}</Box>;
};

export const ExcelTabStructForm = () => {
    const excelTabStruct = useSelector((state: AppState) => state.excelTabEditor.editingExcelTabStruct);
    const currentColHeader = useSelector((state: AppState) => state.excelTabEditor.currentColHeader);

    if (!excelTabStruct) {
        return <></>;
    }
    const update = (p: Partial<ExcelTabStructAttrs>) => {
        appStore.dispatch(excelTabEditorSlice.actions.updateExcelTabStruct({
            ...excelTabStruct,
            ...p
        }));
    };

    const addColumn = () => {
        appStore.dispatch(excelTabEditorSlice.actions.addColumnTabStruct());
    };
    return <Box sx={{ display: 'flex', width: '100%' }}>
        <Box sx={{ minWidth: 300 }}>
            <FormEl>
                <TextField label="Nom de l'extraction" value={excelTabStruct.name} onChange={(event) => update({ name: event.target.value })} />
            </FormEl>
            <FormEl>
                <TextField label="Nom exact du tableau excel" value={excelTabStruct.tabName} onChange={(event) => update({ tabName: event.target.value })} />
            </FormEl>
            <FormEl>
                <Typography>Colonnes à extraire</Typography>
                {excelTabStruct.columns.map((col, index) => <ListItemButton onClick={() => { appStore.dispatch(excelTabEditorSlice.actions.setCurrentColHeader(index)); }} key={index}>{col.header !== '' ? col.header : 'Nouveau'}</ListItemButton>)}
                <ListItemButton onClick={addColumn} ><Add /></ListItemButton>
            </FormEl>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
            <Typography>Colonne</Typography>
            {currentColHeader !== null ? <ExcelTabColumn
                column={excelTabStruct.columns[currentColHeader]}
                index={currentColHeader}
                onUpdate={p => update({
                    columns: excelTabStruct.columns.map((q, i) => i == currentColHeader ? p : q)
                })} /> : <Typography variant='subtitle1'>Sélectionner une colonne...</Typography>}
        </Box>
    </Box>;
};

/*

export type ExcelTabColumnProps = {
    header: string,
    indexInValueArray?: number,
    possibleHeaderNames: string[],
    tabRef?: { tabName: string, rowName: string; };
};
*/

export const ExcelTabColumn = (props: { column: ExcelTabColumnProps, index: number, onUpdate: (attrs: ExcelTabColumnProps) => void; }) => {

    const [newCol, setNewCol] = React.useState('');
    const addNewCol = () => {
        if (newCol) {
            props.onUpdate({
                ...props.column,
                possibleHeaderNames: props.column.possibleHeaderNames.concat([newCol])
            });
            setNewCol('');
        }
    };
    return <Grid2 container>
        <Grid2 size={12}>
            <FormEl>
                <TextField size='small' label="En-tête finale" value={props.column.header} onChange={event => {
                    props.onUpdate({
                        ...props.column,
                        header: event.target.value
                    });
                }} />
            </FormEl>
            <FormEl>
                <Typography variant='caption'>En-tête(s) source</Typography>
                <List>
                    {props.column.possibleHeaderNames.map((p, index) => <ExcelTabColumnPossibleName key={index} name={p} onUpdate={(val: string) => props.onUpdate({
                        ...props.column,
                        possibleHeaderNames: [...props.column.possibleHeaderNames.map((q, i) => {
                            if (i === index) return val;
                            return q;
                        })]
                    })} onDelete={() => {
                        props.onUpdate({
                            ...props.column,
                            possibleHeaderNames: [...props.column.possibleHeaderNames.filter((_q, i) => {
                                return i != index;
                            })]
                        });
                    }} />)}
                    <ListItem>
                        <TextField
                            size='small'
                            onBlur={addNewCol}
                            onKeyUp={event => event.key == 'Enter' && addNewCol()}
                            label="Ajouter nom de colonne"
                            value={newCol}
                            onChange={event => setNewCol(event.target.value)} />
                    </ListItem>
                </List>
            </FormEl>
        </Grid2>
    </Grid2>;
};

export const ExcelTabColumnPossibleName = (props: { name: string, onUpdate: (p: string) => void, onDelete: () => void; }) => {
    const [name, setName] = React.useState(props.name);
    const [editing, setEditing] = React.useState(false);

    React.useEffect(() => {
        setName(props.name);
    }, [props.name]);

    const onEndEditing = () => {
        setEditing(false);
        props.onUpdate(name);
    };

    return <ListItem secondaryAction={<>
        <IconButton onClick={() => setEditing(true)}><Edit /></IconButton>
        <IconButton><Delete /></IconButton>
    </>}>
        {editing ? <TextField size='small' autoFocus onBlur={onEndEditing} onKeyUp={event => event.key == 'Enter' && onEndEditing()} value={name} onChange={event => { setName(event.target.value); }} /> : <ListItemText primary={name} />}
    </ListItem>;
};
